export default __webpack_public_path__ + "static/media/outreach.7d1f5a91.jpg";